import { AppTheme } from './types';

export const detectInitialTheme = (): AppTheme => AppTheme.light;
